<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统日志</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-form :model="querys" ref="querys" label-width="70px" class="search-form" @submit.prevent>
      <el-row>
        <el-form-item label="关键词" prop="keyword">
          <el-col>
            <el-input v-model="querys.keyword" prefix-icon="Search"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="时间范围" label-width="90px">
          <el-col>
            <el-date-picker v-model="dateRange" type="daterange" start-placeholder="开始时间" end-placeholder="结束时间"
              unlink-panels :shortcuts="$util.getShortCuts()" @change="fetchs()" style="max-width:210px;">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="" label-width="20px">
          <el-button type="primary" icon="search" @click="fetchs()">
            搜索
          </el-button>
        </el-form-item>
      </el-row>
    </el-form>

    <basic-table class="table"  :query="querys" @handler="fetchs" :currHandler="currHandler">
    </basic-table>
  </el-card>

</template>

<script>
import { fetchApiLogs } from "@/api/sys";
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
  name: "apiLogs",
  components: { StaticDialog, BasicTable },
  data() {
    return {
      querys: {
        keyword: "",
        filters: [],
        columns: [
          { type: "index", label: "序号" },
          { prop: "id", label: "ID", sortable: true, searchable: true, width: "200", showOverflowTooltip:true },
          { prop: "url", label: "Url", width: "200", sortable: true,  showOverflowTooltip:true },
          { prop: "displayName", label: "DisplayName", sortable: true,  width: "200", showOverflowTooltip:true },
          { prop: "controler", label: "Controler", width: "130", searchable: true, showOverflowTooltip:true },
          { prop: "action", label: "Action", width: "120", searchable: true, showOverflowTooltip:true },
          { prop: "form", label: "Form", width: "130",  searchable: true, showOverflowTooltip:true },
          { prop: "body", label: "Body", width: "200", searchable: true, showOverflowTooltip:true },
          { prop: "result", label: "Result", width: "200",  searchable: true, showOverflowTooltip:true },
          { prop: "ip", label: "IP", width: "90", searchable: true, showOverflowTooltip:true },
          { prop: "userName", label: "UserName", width: "90", searchable: true, },
          { prop: "createDate", label: "CreateDate", width: "180" },
        ],
        sidx: "id",
        sord: "descending",
      },
      currRow: null,
      dateRange: [],
    };
  },
  mounted() {
    this.dateRange = this.$util.getCurrentDate('today');
    this.fetchs();
  },
  methods: {
    fetchs() {
      this.querys.filters = [];
      
      if (this.dateRange && this.dateRange[0])
        this.querys.filters.push({
          name: "createDate",
          value: this.$util.fmtDate(this.dateRange[0], "yyyy-MM-dd"),
          operate: 2,
        });
      if (this.dateRange && this.dateRange[1])
        this.querys.filters.push({
          name: "createDate",
          value: this.$util.fmtDate(this.dateRange[1], "yyyy-MM-dd") + " 23:59:59",
          operate: 3,
        });

      //移除多余的参数
      //let { data, records, total, ...query } = { ...params };
      let { data, records, total, ...search } = {
        ...this.querys,
      };
      // search.filters = [];
      // if (this.querys.keyword)
      //   search.filters.push({
      //     name: "account",
      //     value: "%" + this.querys.keyword + "%",
      //     operate: "like", 5
      //   });
      fetchApiLogs(search).then((res) => {
        this.querys = { ...res.data };
      });
    },
    currHandler(row) {
      this.currRow = row;
    },
    pageHandler(page) {
      this.querys.page = page;
      this.fetchs();
    },
    sizeHandler(rows) {
      this.querys.rows = rows;
      this.fetchs();
    },
    sortHandler(order) {
      this.querys.sidx = order.prop;
      this.querys.sord = order.order;
      this.fetchs();
    },
  },
};
</script>


